import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const generatePartnerAccessKey = createAsyncThunk("partner/access-keys/generate", async (payload) => {
  try {
    const response = await magnifiAPI.generatePartnerAccessKey(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const removePartnerAccessKey = createAsyncThunk("partner/access-keys/remove", async (payload) => {
  try {
    const response = await magnifiAPI.removePartnerAccessKey(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const listPartnerAccessKeys = createAsyncThunk("partner/access-keys/list", async (payload) => {
  try {
    const response = await magnifiAPI.listPartnerAccessKeys(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const renamePartnerAccessKey = createAsyncThunk("partner/access-keys/rename", async (payload) => {
  try {
    const response = await magnifiAPI.renamePartnerAccessKey(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
